import { AssetsDTO } from '../CommonTypes/AssetsDTO';

export interface AssetAllocation extends Omit<AssetsDTO, 'color_group'> {
  colorGroup: number;
}

export const getColorByColorGroup = (assets: AssetsDTO[]): AssetAllocation[] => {
  const colorGroups = ADV.settings.color_groups as string[][];

  const nextColor = colorGroups.map(() => 0);

  return assets.map(asset => {
    const { color, color_group: colorGroup, ...rest } = asset;
    const assetClassColor = color || colorGroups[colorGroup][nextColor[colorGroup]];

    if (!assetClassColor) {
      return {
        color: colorGroups[3][nextColor[colorGroup] % colorGroups[colorGroup].length],
        colorGroup,
        ...rest,
      };
    }

    nextColor[colorGroup] += 1;

    return { color: assetClassColor, colorGroup, ...rest };
  });
};
